<template>
  <div class="container">
	<div class="header-banner-container">
		<div class="header-container">
			<div class="left">
				<img alt="" src="../assets/logo.png">
				<span class="header-title">家庭记账管家</span>
			</div>
			<span class="menus">
				<span class="menu-item" :class="curMenu === 1? 'active' : ''" @click="changeMenu(1)">首页</span>
				<span class="menu-item" :class="curMenu === 2? 'active' : ''" @click="changeMenu(2)">产品介绍</span>
				<span class="menu-item" :class="curMenu === 3? 'active' : ''" @click="changeMenu(3)">联系我们</span>
			</span>
		</div>
		<div class="banner-container">
			<div class="title">
				家庭记账用花叻啥
			</div>
			<div class="desc">
				随时掌握家庭成员消费情况，培养理性消费习惯，形成良好的家庭氛围
				<div id="">
					家庭记账协同参与，记下家庭成长的痕迹，一起打拼的过程
				</div>
			</div>
			<div class="btns">
				<div class="btn-pa">
					<div class="btn" :class="curActive === 1 ? 'active':''" @click="curActive = 1" @mouseenter="curActive = 1" @mouseleave="curActive = 0">
						Android版
					</div>
					<div class="qr-code" v-if="curActive === 1">
						<img src="https://www.hualesha.com/img/android.png  " >
					</div>
				</div>
				<div class="btn-pa">
					<div class="btn" :class="curActive === 2 ? 'active':''" @click="curActive = 2" @mouseenter="curActive = 2" @mouseleave="curActive = 0">
						小程序版
					</div>
					<div class="qr-code" v-if="curActive === 2">
						<img src="../assets/qrcode/miniapp.jpg" >
					</div>
				</div>
				<div class="btn-pa">
					<div class="btn" :class="curActive === 3 ? 'active':''" @click="curActive = 3" @mouseenter="curActive = 3" @mouseleave="curActive = 0">
						网页版
					</div>
					<div class="qr-code" v-if="curActive === 3">
						<img src="../assets/qrcode/QC_webpage.png" >
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="reason-container">
		<div class="reason-title">
			为什么选择
			<span> 花叻啥？</span>
		</div>
		<div class="reason-items">
			<div class="reason-item" v-for="(item, index) in reasonList" :key="item.title">
				<div class="img-div">
					<img :src="require('../assets/reason/icon_choose_' + (index + 1) + '.png')" >
				</div>
				<div class="title">
					{{ item.title }}
				</div>
				<div class="desc">
					{{ item.desc }}
				</div>
			</div>
		</div>
	</div>
	<div class="home-booking-container" id="home-booking-container">
		<div class="left">
			<img src="../assets/icon_triangle.png" class="triangle">
			<div class="title">
				家庭记账
			</div>
			<div class="desc">
				<img src="../assets/icon_check.png" >
				一个家庭一本账，家庭成员能共同查看并管理
			</div>
			<div class="desc">
				<img src="../assets/icon_check.png" >
				与家人一起记录生活，分享现在，共享未来
			</div>
		</div>
		<img src="../assets/img_picture.png" >
	</div>
	<div class="account-mana-container">
		<img src="../assets/img_account.png" >
		<div class="left">
			<img src="../assets/icon_triangle.png" class="triangle">
			<div class="title">
				账户管理
			</div>
			<div class="desc">
				<img src="../assets/icon_check.png" >
				一目了然的清楚自己有多少钱，都分布在什么地方
			</div>
			<div class="desc">
				<img src="../assets/icon_check.png" >
				方便统一管理所有账户，记账后账户余额同步更新
			</div>
		</div>
	</div>
	<div class="budget-container">
		<div class="left">
			<img src="../assets/icon_triangle.png" class="triangle">
			<div class="title">
				预算设置
			</div>
			<div class="desc">
				<img src="../assets/icon_check.png" >
				设置月度预算和分类预算，避免冲动消费！
			</div>
			<div class="desc">
				<img src="../assets/icon_check.png" >
				通过预算提醒控制当前开支，合理规划让家庭更美好
			</div>
		</div>
		<img src="../assets/img_budget.png" >
	</div>
	<div class="statistic-container">
		<div class="left">
			<div class="title" style="color: white">
				账本统计
			</div>
			<div class="desc" style="color: #E1E2F3">
				<img src="../assets/icon_check.png" >
				从多个维度去分析家庭和个人的消费情况
			</div>
			<div class="desc" style="color: #E1E2F3">
				<img src="../assets/icon_check.png" >
				收支结余趋势直观呈现，多种形式统计图智能分析家庭财务
			</div>
		</div>
	</div>
	<div class="user-evaluation-container">
		<div class="title">
			用户评价
		</div>
		<div class="evaluation-list">
			<div class="evaluation-item" v-for="(item, index) in evaluationList">
				<div class="top">
					<img :src="require('../assets/img_user_' + (index + 1) + '.png')" >
				</div>
				<div class="bottom">
					<div class="label">
						{{ item.title }}
					</div>
					<div class="line">
						
					</div>
					<div class="desc">
						{{ item.desc }}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="contact-us-container" id="contact-us-container">
		<div class="top">
			<div class="left">
				<div class="title">
					联系我们
				</div>
				<div class="email">
					如需商务合作或有意见反馈，请发送邮件至hualesha@126.com
				</div>
			</div>
			<img src="../assets/img_applet.png" >
		</div>
		<div class="record">
			<a href="https://beian.miit.gov.cn">
				耶数（苏州）智能技术有限公司
				<div class="dot"></div>
				苏ICP备20021158号
			</a>
		</div>
	</div>
  </div>
</template>

<script>
export default {
	name: 'index',
	data() {
		return {
			curMenu: 1,
			curActive: 0,
			reasonList: [
				{
					title: '准确掌握资金流向与动态',
					desc: '资金洞察'
				},
				{
					title: '账本共享',
					desc: '独有家庭账本，一起记账'
				},
				{
					title: '预算管理',
					desc: '控制消费，减少开支'
				},
				{
					title: '专注记账',
					desc: '无广告、无理财、无社区'
				},
				{
					title: '专业统计',
					desc: '多维度统计收支流水'
				},
				{
					title: '数据无忧',
					desc: '云端备份、定期自动导出'
				},
			],
			evaluationList: [
				{
					title: '半粒小葡萄',
					desc: '软件布局简洁，没有广告，基本功能都有，可以多成员记账，iOS和安卓通用。'
				},
				{
					title: '羊不down',
					desc: '花叻啥可以把我们一家的支付同步。我们各自记账，账单数据会共享，就很方便能让我们看到一个月的收支情况，还有柱状图分析每天消费支出波动，一目了然。'
				},
				{
					title: '炸毛妈妈',
					desc: '分类很多，可以导出账单是令我最惊艳的，每个月都能以excal的形式保存，不怕数据丢失了。'
				}
			]
		}
	},
	mounted() {
		window.addEventListener('scroll', (e) => {
			if (window.pageYOffset < 400) {
				this.curMenu = 1
			}
		})
	},
	methods: {
		changeMenu(index) {
			this.curMenu = index
			window.location.href = index === 2 ? '#home-booking-container' : '#contact-us-container'
		}
	}
}
</script>

<style lang="scss" scoped>
.header-banner-container {
	display: flex;
	flex-direction: column;
	width: 100vw;
	height: 880px;
	background-image: url(../assets/banner.png);
	background-size: 100vw auto;
	background-repeat: no-repeat;
	.header-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-grow: 0;
		width: 100vw;
		padding-top: 32px;
		padding-left: 400px;
		padding-right: 400px;
		box-sizing: border-box;
		.left {
			display: flex;
			align-items: center;
			img {
				width: 40px;
				height: 40px;
			}
			.header-title {
				margin-left: 8px;
				padding-left: 12px;
				font-weight: 500;
				font-size: 24px;
				line-height: 24px;
				color: #FFFFFF;
				border-left: 1px solid #97A8E2;
			}
		}
		.menus {
			display: flex;
			align-items: center;
			.menu-item {
				margin-left: 60px;
				font-weight: 400;
				font-size: 18px;
				line-height: 28px;
				color: #F0ECE9;
				cursor: pointer;
			}
			.active {
				font-weight: 500;
				color: #FFFFFF;
			}
		}
		
	}
	.banner-container {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 400px;
		padding-right: 400px;
		box-sizing: border-box;
		.title {
			font-weight: 600;
			font-size: 52px;
			line-height: 78px;
			color: #FFFFFF;
	
		}
		.desc {
			margin-top: 40px;
			font-weight: 400;
			font-size: 18px;
			line-height: 28px;
			color: #E1E2F3;
		}
		.btns {
			display: flex;
			.btn-pa {
				position: relative;
				margin-top: 80px;
				margin-right: 20px;
				width: 160px;
				height: 189px;
				.btn {
					position: absolute;
					top: 0;
					left: 0;
					z-index: 2;
					width: 160px;
					height: 58px;
					margin-right: 20px;
					font-weight: 400;
					font-size: 18px;
					text-align: center;
					line-height: 58px;
					color: #FFFFFF;
					background: #7571EB;
					border-radius: 40px;
					cursor: pointer;
					&:hover {
						background: #FE8966;
					}
				}
				.qr-code {
					position: absolute;
					top: 29px;
					left: 0;
					z-index: 1;
					display: flex;
					justify-content: center;
					width: 160px;
					height: 160px;
					background: #7571EB;
					border-radius: 0px 0px 32px 32px;
					img {
						margin-top: 44px;
						width: 100px;
						height: 100px;
						border-radius: 10px;
					}
				}
			}
			
		}
	}
}

.reason-container {
	padding-top: 100px;
	padding-bottom: 120px;
	padding-left: 400px;
	padding-right: 400px;
	.reason-title {
		font-weight: 400;
		font-size: 40px;
		text-align: center;
		line-height: 60px;
		color: #252525;
		span {
			font-weight: 600;
		}
	}
	.reason-items {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.reason-item {
			position: relative;
			width: 30%;
			height: 194px;
			margin-top: 104px;
			padding-left: 24px;
			box-sizing: border-box;
			background: #FFFFFF;
			box-shadow: 0px 16px 48px rgba(104, 102, 118, 0.08);
			border-radius: 16px;
			.img-div {
				position: absolute;
				left: 24px;
				top: -44px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 88px;
				height: 88px;
				background-color: white;
				border-radius: 50%;
				box-shadow: 0px 8px 32px rgba(104, 102, 118, 0.08);
				img {
					width: 52px;
					height: 52px;
				}
			}
			.title {
				margin-top: 76px;
				font-weight: 500;
				font-size: 22px;
				line-height: 34px;
				color: #252525;
			}
			.desc {
				margin-top: 16px;
				font-weight: 400;
				font-size: 18px;
				line-height: 28px;
				color: #5E5D5D;
			}
		}
	}
	
}
.home-booking-container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 41px 420px;
	height: 670px;
	background: #EFFAFC;
	
	
	img {
		width: 530px;
		height: 587px;
	}
}
// common
.left {
	position: relative;
	.triangle {
		position: absolute;
		top: -61px;
		left: -20px;
		width: 95px;
		height: 92px;
	}
	.title {
		margin-bottom: 40px;
		font-weight: 500;
		font-size: 40px;
		// line-height: 60px;
		color: #252525;
	}
	.desc {
		display: flex;
		align-items: center;
		margin-top: 16px;
		font-weight: 400;
		font-size: 18px;
		// line-height: 28px;
		color: #5E5D5D;
		img {
			margin-right: 16px;
			width: 28px;
			height: 28px;
		}
	}
}
.account-mana-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 70px 420px 80px 420px;
	img {
		width: 474px;
		height: 520px;
	}
}
.budget-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 100px 320px 85px 420px;
	background-color: #EFFAFC;
	img {
		width: 564px;
		height: 485px;
	}
}
.statistic-container {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 100vw;
	height: 670px;
	padding: 36px 348px 67px 420px;
	box-sizing: border-box;
	background-image: url(../assets/img_statistical.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.user-evaluation-container {
	padding: 100px 400px;
	box-sizing: border-box;
	.title {
		font-weight: 400;
		font-size: 40px;
		text-align: center;
		line-height: 60px;
		color: #252525;
	}
	.evaluation-list {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 40px;
		.evaluation-item {
			width: 30%;
			height: 420px;
			background: #FFFFFF;
			box-shadow: 0px 16px 48px rgba(104, 102, 118, 0.16);
			border-radius: 16px;
			.top {
				width: 100%;
				height: 200px;
				border-radius: 16px 16px 0px 0px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.bottom {
				padding: 16px 32px;
				box-sizing: border-box;
				.label {
					font-weight: 400;
					font-size: 22px;
					line-height: 34px;
					color: #252525;
				}
				.line {
					width: 80px;
					height: 1px;
					margin-top: 8px;
					margin-bottom: 12px;
					background: #FE8966;
				}
				.desc {
					font-weight: 400;
					font-size: 16px;
					line-height: 28px;
					color: #5E5D5D;
				}
			}
		}
	}
}
.contact-us-container {
	padding: 72px 460px 20px 420px;
	box-sizing: border-box;
	background-color: #F1F4F9;
	.top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		img {
			width: 220px;
			height: 220px;
		}
		.title {
			margin-bottom: 40px;
			font-weight: 400;
			font-size: 40px;
			line-height: 60px;
			color: #000000;
		}
		.email {
			margin-bottom: 8px;
			font-weight: 400;
			font-size: 18px;
			line-height: 28px;
			color: #5E5D5D;
		}
	}
	.record {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 100px;
		text-align: center;
		font-weight: 400;
		font-size: 18px;
		line-height: 28px;
		color: #a9a9a9;
		.dot {
			margin-left: 10px;
			margin-right: 10px;
			width: 5px;
			height: 5px;
			background-color: #a9a9a9;
			border-radius: 50%;
		}
	}
}
</style>
